<template>
  <div class="board">
    <div @click="back()" class="power">
      <i style="cursor: pointer; font-size: 0.5rem" class="el-icon-back"></i>
    </div>
    <div class="otherReport">
      <img @click="statisReport()" style="height: 0.7rem" src="../../../assets/img/fr/report.png" />
      <img @click="d8Reponse()" v-if="toConfirm == 'true'" style="height: 0.7rem"
        src="../../../assets/img/fr/respon.png" />
      <img @click="oepnRegisterialog()" style="height: 0.7rem" src="../../../assets/img/fr/scan.png" />
      <img @click="d8Approve()" v-if="toConfirm == 'true'" style="height: 0.7rem"
        src="../../../assets/img/fr/approve.png" />
    </div>
    <!-- <div class="otherTime">
      <span style="margin-top:5px;">更新时间：{{ updateTimeText }}</span>
    </div> -->
    <div class="logoImg">
      <img style="height: 0.8rem" :src="logoSrc" />
    </div>
    <header class="w-100 h-10 flex j-center a-center">
      <!-- <h3 class="title">快速反应跟踪</h3> -->
      <!-- <el-button class="title" type="primary">{{ title }}</el-button> -->
      <div class="font-big font-weight light-title">
        {{ title ? title : "问题解决" }} {{ selectedSource ? ' - ' + selectedSource.title : '' }}
      </div>
    </header>
    <div style="text-align: center; margin-top: 20px" v-if="leftValue.length < 1">
      <h1 style="color: white; font-size: 20px">没有进行中的数据!</h1>
    </div>
    <div class="keyCls" style="position: fixed; z-index: 999; top: 10px; right: 18%;width:3rem;height: 0.5rem;">
      <el-input placeholder="关键字查询" v-model="keyWordValue" class="input-with-select">
        <el-button slot="append" @click="keywordSerach()" icon="el-icon-search"></el-button>
      </el-input>
    </div>
    <div style="padding: 5px;" class="frcar">
      <!-- 自定义左右箭头按钮 -->
      <span class="page-start">
        <i class="el-icon-arrow-left" @click="prevPage"></i>
        <span class="page-number">{{ currentPage }} / {{ screen }}</span>
        <i class="el-icon-arrow-right" @click="nextPage"></i>
      </span>
      
      <div class="carousel-arrows">
        <span class="page-number">更新时间：{{ updateTimeText }}</span>
      </div>
      <!-- 自定义轮播内容 - 表格在 carousel 外部 -->
      <div class="carousel-wrapper">
        <transition name="carousel-slide" mode="out-in">
          <div class="carousel-content" v-for="carou in screen" :key="carou" v-if="frActiveIndex === carou - 1">
        
        <div class="table-show">
          <table class="fr-wrapper">
            <thead
              style="background-color: #072951;box-shadow:-10px 0px 15px #2C58A6 inset,/*左边阴影*/10px 0px 15px #2C58A6 inset;  /*右边阴影*/">
              <tr>
                <th style="font-size:0.24rem;text-align:center;" v-for="(val, key, i) in leftHeader" rowspan="2"
                  :key="'leftHeader-' + i" :class="{ 'fixed-second-col': showKey[i] == 'description' }">
                  <div :style="{
                    'white-space': 'nowrap','min-width': (showKey[i] == 'description' || showKey[i] == 'todoList') ? '5rem' : '1rem'
                  }">
                    <span v-html="key"></span>
                    <a @click="sort(showKey[i])" v-if="showKey[i]">
                      <i v-if="!sortMap[showKey[i]] || sortMap[showKey[i]] == 'ASC'" class="el-icon-arrow-down"></i>
                      <i v-if="sortMap[showKey[i]] == 'DESC'" class="el-icon-arrow-up"></i>
                    </a>
                  </div>
                </th>
                <th style="font-size:0.23rem;" v-for="(val, key, i) in rightTopHeader"
                  :colspan="Object.keys(val).length" :key="'middleHead-' + i">
                  {{ key }}
                </th>
              </tr>
              <tr>
                <th v-for="(f, i) in rightTwoHeader" :key="'rightTwoHeader-' + i">
                  <div style="font-size:0.23rem;">{{ f }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(tr, ind) in dataSlice(carou, leftValue)">
                <tr :key="'leftValue-' + ind" :class="{ ['rowInfo']: diffInDays(tr) }">
                  <td v-for="(td, k) in tr" :key="'left-' + k" @click="oepnIssueDialog(td, showKey[k])" :class="{
                    ['fixed-second-col']: showKey[k] == 'description',
                    ['yellow']: td.value == 'Y',
                    ['green']: td.value == 'G',
                    ['red']: td.value == 'R',
                    ['grey']: td.value == 'V',
                  }">
                    <div class="line-limit-length"
                      :class="{ ['all-row']: (td.value && chatAtLen(td.value) > 10), 'win_color': ((showKey[k] == 'source.title' && (td.value.indexOf('客户') > -1 || td.value.indexOf('供应商') > -1)) || (showKey[k] == 'repeats' && td.value == '是')) }">
                      <template v-if="showKey[k] == 'todoList2' && td.value">
                        <i class="el-icon-view todo-list-icon"></i>
                        <span class="todo-list-text">查看</span>
                      </template>
                      <template v-else>
                        <span style="font-size:.23rem;">{{ removeTAG(td.value, showKey[k]) }}</span>
                        <img src="../../../assets/img/fr/new.png" style="width:30px;vertical-align:middle;"
                          v-if="showKey[k] == 'description' && diffInMinDays(tr)">
                      </template>
                    </div>
                  </td>
                  <td style="font-size:.23rem; padding:0.1rem;" @click="oepnInstanceView(td)"
                    v-for="(td, j) in dataSlice(carou, rightValue)[ind]" :key="'rigth-' + j" :class="{
                      ['yellow']: td.v == 'Y',
                      ['green']: td.v == 'G',
                      ['red']: td.v == 'R',
                      ['grey']: td.v == 'N/A',
                    }">
                    <template v-if="td.proDueDate">
                      <span>{{ formatHour(td.proDueDate) }}</span><br />
                      <hr />
                      <div>&nbsp;<span v-if="td.v == 'G'">{{ formatHour(td.actualDate) }}</span>&nbsp;</div>
                    </template>
                    <template v-else>
                      {{ formatHour(td.dueDate) }}
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      </transition>
      </div>
      <!-- 隐藏的 carousel - 只用作定时器 -->
      <el-carousel indicator-position="none" ref="carousel" arrow="never" :interval="too" @change="handleCarouselChange"
        style="visibility: hidden; position: absolute; pointer-events: none;">
        <el-carousel-item v-for="carou in screen" :key="carou"></el-carousel-item>
      </el-carousel>
    </div>
    <!--问题详情-->
    <el-dialog title="问题清单" :visible.sync="issueDialog" width="75%" :lock-scroll="false" v-loading="issueLoading"
      element-loading-text="加载中..." element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.7)">
      <div v-if="issueData" v-html="issueData"></div>
    </el-dialog>
    <!--流程详情-->
    <el-dialog :title="todoTitle.groupTitle + ' / ' + todoTitle.title" :visible.sync="todoDialog" width="85%"
      :lock-scroll="false" v-loading="instanceLoading" element-loading-text="加载中..."
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.7)">
      <process-view :groupTitle="todoTitle.title" :initData="instanceData"></process-View>
    </el-dialog>
    <!--待办事项-->
    <el-dialog :title="'待办事项'" :visible.sync="todoListDialog" width="60%" center :lock-scroll="false">
      <div>
        <todo-list @todo-change="handleTodoChange" v-model="todoListItem"></todo-list>
      </div>
    </el-dialog>
    <!--签到-->
    <el-dialog :title="'签到'" :visible.sync="frRegisterDialog" width="40%" center :lock-scroll="false">
      <div style="text-align:center;">
        <img :src="qrcodeValue" class="aclass">
      </div>
    </el-dialog>
    <!--下次报告时间-->
    <el-dialog :title="'更新下次汇报日期'" :visible.sync="frNextDateDialog" width="40%" :lock-scroll="false">
      <div style="text-align:center;">
        <el-date-picker style="width:80%" v-model="frNextData.date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
          value-format="timestamp">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="frNextDateDialog = false">取 消</el-button>
        <el-button :loading="nextLoading" type="primary" @click="submitNextDate()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import processView from "../process/board.vue";
import todoList from "../../../components/todo-list/main.vue";
import API from "@/utils/api";
import { Loading } from "element-ui";
import router from "../../../router";
import format from "date-fns/format";
import differenceInDays from "date-fns/differenceInDays";

export default {
  name: "board",
  components: {
    processView,
    todoList
  },
  data() {
    return {
      sortMap: {},
      nextLoading: false,
      todoListLoading: false,
      qrcodeValue: '',
      frNextDateDialog: false,
      frRegisterDialog: false,
      websock: null,
      reconnectData: null,
      lockReconnect: false,
      logoSrc: "/assets/img/logo_light.png",
      title: "快速反应跟踪",
      msg: "home",
      leftHeader: [], // 表头;
      leftValue: [], // 值;
      rightTopHeader: [], // 表头;
      rightTwoHeader: [], // 二级表头;
      rightValue: [], // 值;
      loading: null,
      issueDialog: false,
      todoDialog: false,
      issueData: null,
      issueLoading: false,
      todoData: {},
      instanceData: {},
      instanceLoading: false,
      frNextData: {
        date: null,
        issueUUID: null
      },
      colors: { Y: "#FFCC00", R: "#f44", G: "#06bf04" },
      todoTitle: { title: "", groupTitle: "" },
      frActiveIndex: 0,
      currentPage: 1,
      screen: 10,
      pageSize: 10,
      too: 10000,
      filterField: [
        "responderUUID",
        "ownerUUID",
        "productLine.title",
        "category.title",
        "program.title",
        "source.title",
      ],
      showKey: [],
      keyWordValue: "",
      sortValue: "",
      updateTimeText: null,
      todoListDialog: false,
      todoListItem: [],
      todoItem: {},
      toConfirm: 'false',
      frSource: [],
      selectedSource: null,  // 选中的来源筛选
      carouselHeight: '100vh'  // 默认高度
    };
  },
  mounted() {
    this.onShow();
    this.loadBoardTitle();
    // 初始化
    this.startLoading();
    this.loadFrSource();
    this.webSocket();
    this.init(); //保留http
    this.initStickyObserver(); // 初始化 sticky 检测
  },
  destroyed() {
    if (this.websock) {
      this.lockReconnect = true;
      this.websock.close();
    }
    if (this.stickyHandler) {
      var board = document.querySelector('.board');
      if (board) {
        board.removeEventListener('scroll', this.stickyHandler);
      }
    }
  },
  filters: {},
  methods: {
    // 排序
    sort(key) {
      if (!this.sortMap[key]) {
        this.sortValue = `${key}:DESC`;
        this.sortMap[key] = 'ASC';
      } else if (this.sortMap[key] == 'ASC') {
        this.sortValue = `${key}:ASC`;
        this.sortMap[key] = 'DESC';
      } else {
        this.sortValue = `${key}:DESC`;
        this.sortMap[key] = 'ASC';
      }
      this.init();
    },
    d8Approve() {
      this.$router.push({
        path: "/fr/approve",
        query: {
          key: this.$route.query.key,
        },
      });
    },
    schedule() {
      this.$router.push({
        path: "/fr/schedule",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    statisReport() {
      this.$router.push({
        path: "/fr/statis",
        query: {
          key: this.$route.query.key,
        },
      });
    },
    d8Report() {
      this.$router.push({
        path: "/fr/report",
        query: {
          key: this.$route.query.key,
        },
      });
    },
    d8Reponse(key) {
      this.$router.push({
        path: "/fr/response",
        query: {
          key: this.$route.query.key,
        },
      });
    },
    d8Route() {
      this.$router.push({
        path: "/fr/8d",
        query: {
          key: this.$route.query.key,
        }
      });
    },
    d8Details(item, field) {
      var params = { "issueUUID": item.uuid };
      API.frSend(params)
        .then((res) => {
          if (res.success) {
            this.d8Route();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    oepnIssueDialog(item, field) {
      if (field == 'nextReportDate') {
        this.frNextDateDialog = true;
        this.frNextData['issueUUID'] = item['uuid'];
        this.frNextData['date'] = item.value || null;
      } else if (field == 'todoList') {
        this.todoListItem = [];
        if (item.value) {
          this.todoListItem = JSON.parse(item.value);
        }
        this.todoItem['issueUUID'] = item['uuid'];
        this.todoListDialog = true;
      } else {
        this.issueDialog = true;
        this.issueLoading = true;
        this.issueData = null;
        API.getIssueView(item.uuid)
          .then((res) => {
            this.issueLoading = false;
            if (res.success === true) {
              this.issueData = this.decodeHtml(res.value);
            }
          })
          .catch((error) => {
            this.issueLoading = false;
            console.log(error);
          });
      }
    },
    submitNextDate() {
      var params = this.frNextData;
      if (!params['issueUUID'] || !params['date']) {
        return;
      }
      this.nextLoading = true;
      API.changeNextDate(params)
        .then((res) => {
          this.nextLoading = false;
          if (res.success === true) {
            this.$message.success("更新成功");
            this.frNextDateDialog = false;
            this.init(); //保留http
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.nextLoading = false;
        });
    },
    handleTodoChange() {
      this.todoListLoading = true;
      var params = {};
      params['issueUUID'] = this.todoItem['issueUUID'];
      params['toStr'] = JSON.stringify(this.todoListItem);
      API.changeTodoList(params)
        .then((res) => {
          this.todoListLoading = false;
          if (res.success === true) {
            this.$message.success("更新成功");
            this.init(); //保留http
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log(error);
          this.todoListLoading = false;
        });
    },
    showQrcode(item, showQrcodeModal, type) {
      var category = this.$route.query.key;
      var bean = { "uuid": category };
    },
    diffInDays(data) {
      let len = this.showKey.indexOf("createdTime");
      if (len > -1) {
        var time = data[len]['dateNow'];
        var now = new Date();
        // return differenceInDays(now, time) > 40;
        return false;
      }
      return false;
    },
    diffInMinDays(data) {
      let len = this.showKey.indexOf("createdTime");
      if (len > -1) {
        var time = data[len]['dateNow'];
        var now = new Date();
        return differenceInDays(now, time) < 2;
      }
      return false;
    },
    chatAtLen(str) {
      str = this.removeTAG(str, null);
      var len = str.toString().replace(/[\u0391-\uFFE5]/g, "aa").length;
      return len;
    },
    loadFrSource() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.getFrSource({}).then((re) => {
        if (re.success) {
          this.frSource = re.list;
        }
      });
    },
    loadBoardTitle() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      API.loadTheme().then((re) => {
        if (re.success && re["list"].length > 0) {
          this.logoSrc = re["list"][0]["icon"];
        }
      });
    },

    oepnRegisterialog() {
      var user = localStorage.getItem("user_session");
      if (user == null) {
        router.push("/login");
        return;
      } else {
        user = JSON.parse(user);
        sessionStorage.setItem("token", user.token);
        sessionStorage.setItem("http", user.http);
      }
      var category = this.$route.query.key;
      var bean = { "uuid": category };
      API.getRegister(bean)
        .then((res) => {
          if (res.success) {
            var plan = res['value']
            this.qrcodeValue = `${user.http}/api/fr/register_plan/qrcode/` + plan.code;
            this.frRegisterDialog = true;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    oepnTodoDialog(item) {
      if (!item.process) {
        return;
      }
      this.todoDialog = true;
      this.todoTitle["title"] = item.title;
      this.todoTitle["groupTitle"] = item.groupTitle;

      API.getProcess(item.issue, item.process)
        .then((res) => {
          if (res.success === true) {
            this.todoData = res.value;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    oepnInstanceView(item) {
      if (!item.process) {
        return;
      }
      this.todoDialog = true;
      this.instanceLoading = true;
      this.instanceData = {};
      this.todoTitle["title"] = item.title;
      this.todoTitle["groupTitle"] = item.groupTitle;
      API.getInstanceView(item.issue, item.instance)
        .then((res) => {
          this.instanceLoading = false;
          if (res.success) {
            this.instanceData = res.value;
          }
        })
        .catch((error) => {
          this.instanceLoading = false;
          console.log(error);
        });
    },
    formatRate(data) {
      if (data.total > 0) {
        return parseInt(((data.completed / data.total) * 100).toFixed(0));
      } else {
        return 100;
      }
    },

    start: function () {
      setTimeout(() => {
        this.end(); //娃娃消失
      }, 4000);
    },
    keywordSerach() {
      this.init();
    },
    init() {
      this.startLoading();
      var params = {};
      if (this.keyWordValue) {
        params["keyword"] = this.keyWordValue;
      }
      if (this.sortValue) {
        params["sort"] = this.sortValue;
      }
      if (this.selectedSource) {
        params["source"] = this.selectedSource['uuid'];
      }

      API.getIssueDp(this.$route.query.key, params)
        .then((res) => {
          if (res.success === true) {
            if (res.value.title) {
              this.title = res.value.title;
            } else {
              this.title = "快速反应跟踪";
            }
            this.format(res.value);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    //格式化数据
    format(res) {
      this.toConfirm = this.$route.query.toConfirm
      this.leftHeader = res.mapMain;
      this.showKey = res["sortKey"];
      let length = 0;
      for (let key in res.mapMain) {
        length = res.mapMain[key].length;
      }
      const data = [];
      for (let i = 0; i < length; i++) {
        const obj = [];
        for (let key in res.mapMain) {
          if (res.mapMain[key][i].value > 1970 * 356 * 24 * 60 * 1000) {
            const dateNow = new Date(res.mapMain[key][i].value);
            res.mapMain[key][i]['dateNow'] = dateNow;
            res.mapMain[key][i].value = `${dateNow.getFullYear()}/${dateNow.getMonth() + 1
              }/${dateNow.getDate()}`;
            obj.push(res.mapMain[key][i]);
          } else if (res.mapMain[key][i].value === 0) {
            res.mapMain[key][i].value = '- -';
            obj.push(res.mapMain[key][i]);
          } else {
            obj.push(res.mapMain[key][i]);
          }
        }
        data.push(obj);
      }
      this.leftValue = [];
      this.leftValue = data;
      // 二层表;
      this.rightTopHeader = res.mapItem;
      const twoData = [];
      for (let i = 0; i < length; i++) {
        const obj = [];
        for (let key in res.mapItem) {
          for (let name in res.mapItem[key]) {
            if (res.mapItem[key][name][i]) {
              obj.push(res.mapItem[key][name][i]);
            } else {
              obj.push("数据错误");
            }
          }
        }
        twoData.push(obj);
      }

      this.rightTwoHeader = [];

      for (let key in res.mapItem) {
        for (let name in res.mapItem[key]) {
          this.rightTwoHeader.push(name);
        }
      }
      this.rightValue = [];
      this.rightValue = twoData;

      this.screen = Math.ceil(twoData.length / this.pageSize);

      // 动态计算表格宽度
      const totalColumns = Object.keys(this.leftHeader).length + this.rightTwoHeader.length;
      const columnWidth = 1.5;
      const tableWidth = totalColumns * columnWidth;
      const frcarElement = document.querySelector('.frcar');
      if (frcarElement) {
        // 默认撑满屏幕(100%)，但最小宽度保证内容完整显示
        frcarElement.style.width = '100%';
        frcarElement.style.minWidth = tableWidth + 'rem';
      }

      // 动态计算 carousel 高度
      this.updateCarouselHeight();

      // 数据更新后重新检测 sticky 状态
      this.$nextTick(function() {
        if (this.stickyHandler) {
          this.stickyHandler();
        }
      });

      this.endLoading();
      var now = new Date();
      this.updateTimeText = format(now, "MM-dd HH:mm:ss");

    },

    dataSlice(index, data) {
      var open = (index - 1) * this.pageSize;
      var end = index * this.pageSize;
      return data.slice(open, end);
    },
    webSocket() {
      var http = sessionStorage.getItem("http");
      var uuid = this.$route.query.key;
      if (http) {
        http += "/websocket/fr/issue/keep";
      } else {
        http = "https://demo.biqs.cn/websocket/fr/issue/keep";
      }

      http = http.replace("https", "wss").replace("http", "ws");

      this.websock = new WebSocket(http);
      this.websock.onopen = this.websocketonopen; //连接成功
      this.websock.onmessage = this.websocketonmessage; //广播成功
      this.websock.onerror = this.websocketonerror; //连接断开，失败
      this.websock.onclose = this.websocketclose;

      let this_ = this;

      //建议加上以下这一行代码，不加的效果图如下（当浏览器窗口缩小的时候）。超过了div的界限（红色边框）
      // window.addEventListener("resize", function() {
      //   myChart.resize();
      // });
    },
    //连接成功
    websocketonopen() {
      console.log("FR socket 连接成功");
    },

    //连接失败
    websocketonerror() {
      console.log("FR socket 连接失败");
      this.reconnect();
    },

    //各种问题导致的 连接关闭
    websocketclose() {
      console.log(" FR socket 断开连接");
      this.reconnect();
    },
    //数据接收
    websocketonmessage(data) {
      //刷新
      this.init();
    },

    //断开重连
    reconnect() {
      if (this.lockReconnect) {
        return;
      }
      this.reconnectData && clearTimeout(this.reconnectData);
      this.reconnectData = setTimeout(() => {
        this.webSocket();
      }, 5000);
    },
    startLoading: function () {
      this.loading = Loading.service({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    endLoading: function () {
      this.loading.close();
    },
    onShow() {
      localStorage.getItem("setUp");
      var setUp = localStorage.getItem("setUp");
      if (setUp) {
        setUp = JSON.parse(setUp);
        this.pageSize = setUp["pageSize"];
        this.too = setUp["too"] * 1000;
      }
    },
    removeTAG(str, field) {
      if (field == 'todoList' && str) {
        var val = JSON.parse(str);
        if (val && Array.isArray(val) && val.length > 0) {
          const item = val.find((w) => w.completed === false);
          return item ? item['text'] : val[0]['text'];
        } else {
          return str;
        }
      } else {
        if (str && typeof (str) === 'string') {
          return str.replace(/<[^>]+>/g, "");
        } else {
          return str;
        }
      }
    },
    formatDate(time) {
      if (time) {
        console.log(time);
        var date = new Date(Number(time));
        return format(date, "yyyy-MM-dd");
      }
      return "";
    },
    decodeHtml(html) {
      if (!html) return "";
      const textArea = document.createElement('textarea');
      textArea.innerHTML = html;
      return textArea.value;
    },
    formatHour(time) {
      if (time) {
        var date = new Date(Number(time));
        return format(date, "MM/dd");
      }
      return "";
    },
    back() {
      router.back();
    },
    // 上一页
    prevPage() {
      this.$refs.carousel.prev();
    },
    // carousel 切换事件
    handleCarouselChange(index) {
      this.frActiveIndex = index;
      this.currentPage = index + 1;
    },
    // 来源筛选事件
    handleSourceFilter(source) {
      this.selectedSource = source;
      this.frActiveIndex = 0; // 重置页码
      this.currentPage = 1;
      this.init();
    },
    // 下一页
    nextPage() {
      this.$refs.carousel.next();
    },
    // 动态更新 carousel 高度
    updateCarouselHeight() {
      this.$nextTick(() => {
        const rows = document.querySelectorAll('.fr-wrapper tbody tr');
        const rowCount = rows.length;

        if (rowCount > 0) {
          // 计算高度：表头约60px + 每行约40px + 底部间距
          const headerHeight = 250;
          const rowHeight = 120;
          const padding = 20;
          const calculatedHeight = headerHeight + (rowCount * rowHeight) + padding;

          // 取计算高度和视口高度的较小值
          const finalHeight = Math.min(calculatedHeight, window.innerHeight - 100);

          // 设置响应式变量
          this.carouselHeight = finalHeight + 'px';
        }
      });
    },
    // 初始化 sticky 状态检测
    initStickyObserver() {
      var self = this;

      // 监听滚动事件
      this.stickyHandler = function() {
        var board = document.querySelector('.board');
        if (!board) return;

        var boardRect = board.getBoundingClientRect();
        var stickyCols = document.querySelectorAll('.fixed-second-col');

        stickyCols.forEach(function(col) {
          var rect = col.getBoundingClientRect();
          // 当元素左侧到达 board 左侧时，说明已经 sticky 了
          if (rect.left <= boardRect.left + 1) {
            col.classList.add('is-stuck');
          } else {
            col.classList.remove('is-stuck');
          }
        });
      };

      var board = document.querySelector('.board');
      if (board) {
        board.addEventListener('scroll', this.stickyHandler);
        // 初始检查
        setTimeout(this.stickyHandler, 100);
      }
    }
  },
};
</script>
<style>
.keyCls .el-input__inner {
  background-color: black !important;
  border-radius: 0 !important;
  color: #ffffff;
}

.rowInfo {
  color: black;
  background-color: red;
}

.win_color {
  color: yellow;
}

.frcar .el-carousel__indicator--vertical .el-carousel__button {
  width: 12px;
  height: 30px;
}

/* 自定义左右箭头按钮 */
.carousel-arrows {
  position: absolute;
  right: 3vh;
  top: 60px;
  z-index: 999;
  display: flex;
  gap: 15px;
}

.page-start i {
  width: 3vh;
  height: 3vh;
  line-height: 3vh;
  text-align: center;
  font-size: 24px;
  color: #fff;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.page-start i:hover {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(245, 87, 108, 0.5);
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src='./board.css'></style>



// WEBPACK FOOTER //
// src/pages/fr/board/board.vue